import { XClose } from "@untitledui/icons"
import { motion, useReducedMotion } from "motion/react"

// "Turn sideways for the whole car": a car is wide, and a phone held
// sideways puts more pixels on it. A small pill over the top of the
// picture (like the phone's own camera hints): asked, never forced. It goes
// by itself once the phone is sideways, and its × puts it away for this
// camera visit. Close-ups and the VIN are best upright, so sideways there it
// asks the other way. The phone turns twice to show what's meant, then
// rests (still with reduced motion).

export const ROTATE_COPY = {
  sideways: "Turn sideways for the whole car.",
  keep: "Keep it upright",
  upright: "Turn upright for this one.",
}

export function RotatePrompt({ mode, onKeep }: { mode: "sideways" | "upright"; onKeep?: () => void }) {
  const reduce = useReducedMotion()
  const toSideways = mode === "sideways"
  return (
    <div
      className="flex min-h-11 max-w-full items-center gap-2.5 rounded-full bg-black/70 pl-3.5 pr-0 shadow-lg ring-1 ring-white/10 backdrop-blur-md"
      data-testid="rotate-prompt"
      data-mode={mode}
    >
      <motion.svg
        viewBox="0 0 24 24"
        className="size-5 shrink-0"
        aria-hidden
        initial={{ rotate: toSideways ? 0 : 90 }}
        animate={
          reduce
            ? { rotate: toSideways ? 90 : 0 }
            : { rotate: toSideways ? [0, 0, 90, 90, 0, 0, 90] : [90, 90, 0, 0, 90, 90, 0] }
        }
        transition={reduce ? { duration: 0 } : { duration: 3, times: [0, 0.15, 0.3, 0.5, 0.65, 0.8, 1], ease: [0.2, 0, 0, 1] }}
      >
        <rect x="7" y="2.5" width="10" height="19" rx="2.5" fill="none" stroke="white" strokeWidth="1.8" />
        <path d="M10.5 18.5h3" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
      </motion.svg>
      <p className={`py-2 text-[15px] font-medium leading-snug text-white ${toSideways && onKeep ? "" : "pr-4"}`}>
        {toSideways ? ROTATE_COPY.sideways : ROTATE_COPY.upright}
      </p>
      {toSideways && onKeep && (
        <button
          type="button"
          onClick={onKeep}
          aria-label={ROTATE_COPY.keep}
          className="grid size-11 shrink-0 place-items-center rounded-full text-white/75 hover:bg-white/10 hover:text-white focus-visible:outline-2 focus-visible:outline-white"
        >
          <XClose className="size-4" aria-hidden />
        </button>
      )}
    </div>
  )
}
